import { ComponentDefinitionBuilder } from 'nest/platform/models';
import { capabilities } from '../../capabilities';
import { MARKETPLACE_MODAL_COMPONENT, NC_PLATFORM_NAME } from '../constants';
export const marketplaceModalComponentDef = ComponentDefinitionBuilder.builder(MARKETPLACE_MODAL_COMPONENT).setPath('/marketplace-embed/:portalId/navigation-modal').setCapabilityDefs([capabilities.HIDE_COMPONENT_CAP]).setPlatformName(NC_PLATFORM_NAME).setIframeProps({
  style: {
    width: 0,
    height: 0
  }
}).build();